import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
const MAX_NAME_LENGTH = 10;

export default function TracksDropdown(props) {
    function getTruncatedName(track) {
        let name = track.getName();
        if (name === undefined) {
            return '';
        }
        if (name.length >= MAX_NAME_LENGTH) {
            return name.slice(0, MAX_NAME_LENGTH) + '...';
        }

        return name;
    }
    
    function getOptions() {
        let options = props.sequencerEngine.tracks
            .filter(x =>
                    props.trackToSkip === undefined ||
                    x !== props.trackToSkip)
            .map(getSelectedOption);

        return [{label: 'None', value: null}, ... options];
    }

    function getSelectedOption(track=props.track) {
        if (track === undefined) {
            return undefined;
        }
        return {
            value: track,
            label: (track.trackNumber + 1) + '. ' + getTruncatedName(track)
        };
    }

    let className = props.className ?
        props.className + ' tracks-dropdown-container' :
        'tracks-dropdown-container';

    return (
        <div
          className={className}>
          <Dropdown
            className='osc-type-dropdown'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={getOptions()}
            onChange={o => props.onSelectTrack(o.value)}
            value={getSelectedOption()}
            placeholder="Track" />
        </div>
    );
}
